/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateLineItemRequest
 */
export interface UpdateLineItemRequest {
    /**
     * 
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    roomId?: number | null;
    /**
     * ID of the match group to assign this item to. Pass null to unmatch.
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    lineItemMatchGroupId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLineItemRequest
     */
    description?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    quantity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLineItemRequest
     */
    unit?: string | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    unitPriceCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    taxCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    opCents?: number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateLineItemRequest
     */
    rcvCents?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateLineItemRequest
     */
    lineItemNumber?: string | null;
}

/**
 * Check if a given object implements the UpdateLineItemRequest interface.
 */
export function instanceOfUpdateLineItemRequest(value: object): value is UpdateLineItemRequest {
    return true;
}

export function UpdateLineItemRequestFromJSON(json: any): UpdateLineItemRequest {
    return UpdateLineItemRequestFromJSONTyped(json, false);
}

export function UpdateLineItemRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLineItemRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'roomId': json['roomId'] == null ? undefined : json['roomId'],
        'lineItemMatchGroupId': json['lineItemMatchGroupId'] == null ? undefined : json['lineItemMatchGroupId'],
        'description': json['description'] == null ? undefined : json['description'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'unit': json['unit'] == null ? undefined : json['unit'],
        'unitPriceCents': json['unitPriceCents'] == null ? undefined : json['unitPriceCents'],
        'taxCents': json['taxCents'] == null ? undefined : json['taxCents'],
        'opCents': json['opCents'] == null ? undefined : json['opCents'],
        'rcvCents': json['rcvCents'] == null ? undefined : json['rcvCents'],
        'lineItemNumber': json['lineItemNumber'] == null ? undefined : json['lineItemNumber'],
    };
}

export function UpdateLineItemRequestToJSON(json: any): UpdateLineItemRequest {
    return UpdateLineItemRequestToJSONTyped(json, false);
}

export function UpdateLineItemRequestToJSONTyped(value?: UpdateLineItemRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'roomId': value['roomId'],
        'lineItemMatchGroupId': value['lineItemMatchGroupId'],
        'description': value['description'],
        'quantity': value['quantity'],
        'unit': value['unit'],
        'unitPriceCents': value['unitPriceCents'],
        'taxCents': value['taxCents'],
        'opCents': value['opCents'],
        'rcvCents': value['rcvCents'],
        'lineItemNumber': value['lineItemNumber'],
    };
}

